import { useState } from 'react';
import useLocalStorage from '@illinois/react-use-local-storage';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import { MAX_RECENT_ADDRESS_SIZE } from '../../utils/Config';
import filterDirtyAddresses from '../../utils/FilterDirtyAddresses';

function getTopResults(addresses) {
  if (addresses && addresses.length) {
    return addresses.slice(0, 3).map((address) => ({ saved: true, ...address }));
  }
  return [];
}

function getMatchedResults(addresses, query) {
  const lowerCaseQuery = query.toLowerCase();

  if (addresses && addresses.length) {
    const matchedAddresses = filter(
      addresses,
      (address) => (address.address && address.address.toLowerCase().indexOf(lowerCaseQuery) !== -1)
        || (address.name && address.name.toLowerCase().indexOf(lowerCaseQuery) !== -1)
      ,
    );
    return matchedAddresses.map((address) => ({ saved: true, ...address }));
  }
  return [];
}

const useLocalAddress = (addressCategory) => {
  const [storedAddresses, setStoredAddresses] = useLocalStorage(addressCategory, []);
  const cleanAddresses = filterDirtyAddresses(storedAddresses);
  const [filteredAddresses, setFilteredAddresses] = useState(cleanAddresses);

  if (cleanAddresses.length !== storedAddresses.length) {
    setStoredAddresses(cleanAddresses);
  }

  const addAddress = (address) => {
    const index = findIndex(cleanAddresses, { address: address.address });
    if (index !== -1) {
      cleanAddresses.splice(index, 1);
    }
    // add the address to the recent list when it is not included currently.
    const length = cleanAddresses.unshift(address);
    if (length > MAX_RECENT_ADDRESS_SIZE) {
      cleanAddresses.pop();
    }

    setStoredAddresses(cleanAddresses);
  };

  const filterAddresses = (query) => setFilteredAddresses(getTopResults(getMatchedResults(cleanAddresses, query)));

  return {
    addresses: cleanAddresses,
    filteredAddresses,
    addAddress,
    filterAddresses,
  };
};

export default useLocalAddress;
